const settings = {
    tabs: {
      profile: 'プロフィール',
      security: 'セキュリティ',
      notifications: '通知',
      preferences: '環境設定',
      administration: '管理',
    },
    profileDescription: 'サインイン中のアカウント情報です。',
    notificationsDescription: '通知の受け取り方を設定します。',
    security: {
      device: 'デバイス',
      ipAddress: 'IPアドレス',
      lastActive: '最終アクセス',
      status: '状態',
      signOut: 'サインアウト',
      signOutConfirm: {
        title: 'セッションを終了',
        description:
          'このデバイスのセッションを終了します。該当デバイスは再度サインインが必要になり、この操作は取り消せません。終了してもよろしいですか？',
        confirm: '終了する',
      },
      removeDeviceConfirm: {
        title: '信頼済みデバイスを削除',
        description:
          '「{{deviceName}}」の信頼を解除します。次回のサインイン時に多要素認証が必要になり、この操作は取り消せません。削除してもよろしいですか？',
        confirm: '削除',
      },
      unknownDevice: '不明なデバイス',
      mfaDescription: 'サインイン時の追加認証の状態です。',
      sessionsDescription: '現在このアカウントにサインインしているデバイスです。',
      trustedDevicesDescription: '追加認証を省略できるデバイスです。',
    },
    title: '設定',
    description: 'アプリケーションの表示設定や通知設定をカスタマイズします',
    appearance: '表示設定',
    theme: 'テーマ',
    themeLight: 'ライト',
    themeDark: 'ダーク',
    language: '言語設定',
    selectLanguage: '表示言語',
    languageOptions: {
      japanese: '日本語',
      english: 'English',
    },
    notifications: '通知設定',
    enableNotifications: 'アプリ内通知を有効にする',
    emailNotifications: 'メール通知を受け取る',
    notificationNote: '通知設定はブラウザに保存されます。',
    activityTitle: 'アクティビティ・監査ログ',
    activityDescription: 'ログイン、ドキュメント、チャット、CAD、DRBFM などテナント内の操作履歴を確認できます（manager 以上）。',
    openActivityDashboard: 'アクティビティ ダッシュボードを開く',
    openAnomalyTriage: '異常検知イベントを確認する',
    systemTitle: 'システム設定',
    systemDescription: 'システムの設定と管理を行います',
    searchSettings: '検索設定',
    tenantSettingsFetchFailed: 'テナント設定の取得に失敗しました',
    keywordMatching: 'キーワードマッチ処理',
    keywordMatchingTooltip: 'ONの場合、検索クエリを前処理して同義語展開・キーワード抽出を行います。OFFの場合、セマンティック検索（AIによる意味理解）のみを使用します。',
    keywordMatchingEnabled: 'キーワードマッチを有効にしました',
    keywordMatchingDisabled: 'キーワードマッチを無効にしました（セマンティック検索のみ使用）',
    keywordMatchingEnabledDescription: '有効: クエリを前処理し、同義語展開・キーワード抽出を行います',
    keywordMatchingDisabledDescription: '無効: セマンティック検索（RAG）のみを使用します',
    updateFailed: '設定の更新に失敗しました',
    adminRequired: 'この設定を変更するには管理者権限が必要です',
    featureSettings: '機能設定',
    designVerification: '設計検証',
    designVerificationTooltip: 'ONの場合、サイドバー・ダッシュボード・DRBFMから設計検証機能を利用できます。OFFの場合、画面と API の両方で利用できません。',
    designVerificationEnabled: '設計検証を有効にしました',
    designVerificationDisabled: '設計検証を無効にしました',
    designVerificationEnabledDescription: '有効: 設計検証項目一覧を利用できます',
    designVerificationDisabledDescription: '無効: 設計検証の導線と API を停止します',
    searchModesTitle: '検索モードについて',
    keywordMatchOnLabel: 'キーワードマッチON',
    keywordMatchOnDescription: '入力された検索文を解析し、同義語の展開やキーワード抽出を行ってから検索します。特定の用語や製品名での検索に適しています。',
    keywordMatchOffLabel: 'キーワードマッチOFF',
    keywordMatchOffDescription: 'AIが検索文の意味を直接理解し、セマンティック検索を行います。自然な質問文での検索に適しています。',
    dataManagement: 'データ管理',
    currentStatus: '現在の状態',
    registeredDocuments: '• 登録ドキュメント数: {{count}}件',
    defaultBackup: '• デフォルトバックアップ: {{status}}',
    available: '利用可能',
    unavailable: '利用不可',
    dataResetTitle: 'データリセット機能について',
    dataResetDescription: 'この機能は、ドキュメントメタデータを保存されたデフォルト状態に復元します。現在アップロードされているすべてのドキュメント情報が、バックアップされた状態に戻ります。',
    warningLabel: '注意',
    dataResetWarning: 'この操作は元に戻せません。現在のデータはバックアップされた状態に上書きされます。',
    resetToDefault: 'デフォルト状態にリセット',
    resetting: 'リセット中...',
    resetComplete: '✓ リセット完了: {{count}}件のドキュメントを復元しました',
    resetFailed: 'リセットに失敗しました',
    resetError: 'エラー: {{message}}',
    resetConfirmTitle: 'データリセットの確認',
    resetConfirmQuestion: '本当にデータをデフォルト状態にリセットしますか？',
    resetConfirmDescription: 'この操作により、現在のドキュメントメタデータがバックアップされた状態に復元されます。',
    irreversible: 'この操作は元に戻せません。',
    executeReset: 'リセットを実行',
  };

export default settings;
